document.addEventListener('DOMContentLoaded', function () {
    const copyIcons = document.querySelectorAll('.coupon');

    copyIcons.forEach(function (copyIcon) {
      copyIcon.addEventListener('click', function () {
        const codeContainer = this;
        const coupon_text = codeContainer.querySelector('.coupon_text');
        const coupon_code = codeContainer.querySelector('.coupon_code');
        const couponCode = codeContainer.getAttribute('data-coupon-code');

        const textToCopy = coupon_code;

        navigator.clipboard
          .writeText(textToCopy)
          .then(() => {
            coupon_code.style.display = 'block';
            coupon_text.style.display = 'none';

            setTimeout(() => {
              coupon_code.style.display = 'none';
              coupon_text.style.display = 'block';
            }, 3000);
          })
          .catch((err) => {
            console.error('复制失败:', err);
          });
      });
    });
  });